import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/noto-sans-sinhala/400.css';
import '@fontsource/noto-sans-sinhala/500.css';
import '@fontsource/noto-sans-sinhala/600.css';
import '@fontsource/noto-sans-tamil/400.css';
import '@fontsource/noto-sans-tamil/500.css';
import '@fontsource/noto-sans-tamil/600.css';
import './i18n';
import { useLanguageStore } from './stores/languageStore';
import { App } from './App';
import './styles/globals.css';

// Sync <html lang> with the persisted language before first paint. The
// languageStore's onRehydrateStorage handles this when persistence rehydrates,
// but reading it once here covers the case where rehydration hasn't fired yet.
document.documentElement.lang = useLanguageStore.getState().language;

const container = document.getElementById('root');
if (!container) throw new Error('Root container #root not found');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
